import { ReactElement } from 'react';
import classNames from 'classnames';
import { Link } from 'lucide-react';
import { Placement } from '@popperjs/core';
import Tippy from '@tippyjs/react';
import { UiTooltipTheme } from '@nx-frontend/shared/types';

// Тултип на базе popperjs, рендерится в корне body, предотвращает проблемы с перекрытием контейнерами с overflow свойством

interface TippyTooltipProps {
  children: ReactElement;
  message?: string | ReactElement;
  additionalMessage?: string | null | ReactElement;
  position?: Placement;
  show?: boolean;
  hideOnMod?: boolean;
  theme?: UiTooltipTheme;
  messageClasses?: string;
  additionalMessageClasses?: string;
  display?: string;
  tooltipLink?: { linkText: string; linkUrl: string };
  touch?: boolean | 'hold' | ['hold', number] | undefined;
  interactive?: boolean;
}

export function TippyTooltip({
  message,
  messageClasses,
  children,
  hideOnMod = false,
  additionalMessage,
  additionalMessageClasses,
  position,
  show = true,
  theme = UiTooltipTheme.DARK,
  display = 'flex',
  tooltipLink,
  touch = false,
  interactive = false,
  ...props
}: TippyTooltipProps) {
  if (!show) {
    return children;
  }

  const isDarkTheme = theme === UiTooltipTheme.DARK;
  let additionalMessageToShow: ReactElement | null = null;
  if (additionalMessage) {
    additionalMessageToShow = (
      <span className={classNames('mt-3 text-neutral-400', additionalMessageClasses)}>{additionalMessage}</span>
    );
  }

  const tooltipClasses = classNames(
    'flex-col',
    'font-bold',
    'items-start',
    'text-xs',
    'rounded shadow-md p-1 shadow-black-300 scale-100 w-max',
    {
      'flex': !hideOnMod,
      'hidden sm:flex': hideOnMod,
      'bg-neutral-800 text-white border': isDarkTheme,
      'bg-white text-black': !isDarkTheme,
    },
    messageClasses
  );

  return (
    <Tippy
      content={
        <div className={tooltipClasses} data-cy="tooltip-check" {...props}>
          {tooltipLink ? (
            <div className="flex flex-row justify-center">
              <div>
                {message}
                {additionalMessageToShow}
              </div>
              <Link href={tooltipLink.linkUrl} target="_blank" className=" text-teal-500 hover:text-teal-400 p-4">
                {tooltipLink.linkText}
              </Link>
            </div>
          ) : (
            <>
              {message}
              {additionalMessageToShow}
            </>
          )}
        </div>
      }
      arrow={false}
      delay={[1000, 300]}
      duration={300}
      placement={position}
      interactive={Boolean(tooltipLink) || interactive}
      touch={touch}
    >
      {children}
    </Tippy>
  );
}
